import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TgFormfieldDirective } from "./tg-formfield.directive";
import { TgFormfieldLabelDirective } from "./tg-formfield-label.directive";
import { TgHintDirective } from "./tg-hint.directive";
import { TgInputDirective } from "./tg-input.directive";
import { TgInputContainerDirective } from "./tg-input-container.directive";
import { TgLabelDirective } from "./tg-label.directive";
import { TgPrefixDirective } from "./tg-prefix.directive";
import { TgSuffixDirective } from "./tg-suffix.directive";

@NgModule({
	declarations: [
		TgInputDirective,
		TgInputContainerDirective,
		TgLabelDirective,
		TgFormfieldDirective,
		TgHintDirective,
		TgSuffixDirective,
		TgPrefixDirective,
		TgFormfieldLabelDirective,
	],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [
		TgFormfieldDirective,
		TgFormfieldLabelDirective,
		TgHintDirective,
		TgInputContainerDirective,
		TgInputDirective,
		TgLabelDirective,
	],
})
export class TgFormsModule {}
